import { Autocomplete, Divider, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import React, { useContext } from 'react'
import GlobalButton from '../../utility/globalButton/button'
import { tagDataInterface } from '../../../models/axiosModel'
import styles from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import AddIcon from '@mui/icons-material/Add';
import { flagAddTagDialogObj } from '../contacts/contactsGlobal';
import style from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import globalStyles from '../../../assets/styles/global.module.scss';
import RenderCustomOption from '../../global/autocomplete/renderCustomOption';
import { hasContactManageAccess } from '../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { getCustomTagOption, isGenericTag, isOptOutMetaTag } from '../contacts/contactConstant';
import { filterAutocompleteOptionsWithException } from '../../../utils/constants';
function ContactTagActionPopup(props: any) {
    const { contactTagActionData, contactTagData, onChangeContactTagActionData, setFlagAddTagDialogObj, handleSaveAction, handleClose, onClickOfDeleteTag } = props

    const { apiRoutesPermissionAssignment, userDetail } = useContext(UserContext) as UserContextPayload;  

    function getTagOptions() {
        return contactTagData ? [...(contactTagData), ...(getCustomTagOption(apiRoutesPermissionAssignment, userDetail))] : getCustomTagOption(apiRoutesPermissionAssignment, userDetail)
    }

    const onClickOfCustomTagOption = (flagEditOption: boolean, option?: tagDataInterface) => {
        setFlagAddTagDialogObj((prev: flagAddTagDialogObj) => ({
            ...prev,
            flag: true, 
            flagFromEditContactDialog: false,
            ...(flagEditOption && {
                selectedTag: option
            })
        }))
    }
    return (
        <Grid item>
            <Grid container direction={"column"} sx={{ padding: "25px" }} gap="18px">
                <Grid item className={style.contactsSelectedInfo}>{contactTagActionData.preSelectedContacts.length} Contacts Selected</Grid>
                <Grid item>
                    <FormControl>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            row
                            value={contactTagActionData.flagAssignTag}
                            onChange={(event) => { onChangeContactTagActionData('flagAssignTag', event.target.value === 'true') }}
                        >
                            <FormControlLabel className={globalStyles.radioLabelStyle} value={true} control={<Radio className={globalStyles.radioButton} />} label="Tags Action" />
                            <FormControlLabel className={globalStyles.radioLabelStyle} value={false} control={<Radio className={globalStyles.radioButton} />} label="Delete Contacts" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                {contactTagActionData.flagAssignTag &&
                    <>
                        <Grid item>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                    row
                                    value={contactTagActionData.flagRemove}
                                    onChange={(event) => { onChangeContactTagActionData('flagRemove', event.target.value === 'true') }}
                                >
                                    <FormControlLabel className={globalStyles.radioLabelStyle} value={false} control={<Radio className={globalStyles.radioButton} />} label="Add Tags" />
                                    <FormControlLabel className={globalStyles.radioLabelStyle} value={true} control={<Radio className={globalStyles.radioButton} />} label="Remove Tags" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <Grid container direction={"column"} gap="7px">
                                <Grid item className={style.assignTagsListTypography}>Select Tags to {!contactTagActionData.flagRemove ? ` Assign` : ` Remove`}</Grid>
                                <Grid item>
                                    <Autocomplete
                                        className={`${styles.contactFilterDropdownsInPopup}`}
                                        options={getTagOptions()}
                                        getOptionLabel={(option) => option?.contact_tag_name || ''}
                                        filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "contact_tag_name", "contact_tag_id")}
                                        multiple
                                        value={contactTagData && contactTagData?.length > 0
                                            ? contactTagData.filter((tag: any) =>
                                                contactTagActionData.tagsToAssign.some((tagData: any) => tag.contact_tag_id === tagData.contact_tag_id)
                                            ) : []
                                        }
                                        onChange={(_: React.SyntheticEvent, value: tagDataInterface[]) => {
                                            onChangeContactTagActionData('tagsToAssign', value);
                                        }}
                                        // ListboxProps={{ className: style.listBoxCustomStyle }}
                                        renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: tagDataInterface) => { 
                                            return (
                                                <RenderCustomOption 
                                                    autocompleteRenderOptionProps={props} 
                                                    option={option} 
                                                    customOptionName={"New Tag"} 
                                                    optionName={option['contact_tag_name']} 
                                                    optionLabelKey={'contact_tag_id'} 
                                                    onClickOfCustomOption={() => onClickOfCustomTagOption(false)} 
                                                    flagShowEditOptionIcon={hasContactManageAccess(apiRoutesPermissionAssignment, userDetail) && !isGenericTag(option?.contact_list_id)}
                                                    onClickOfEditOption={(e: React.MouseEvent<HTMLDivElement, MouseEvent>, option: tagDataInterface) => {e.stopPropagation(); onClickOfCustomTagOption(true, option)}}
                                                    flagShowDeleteOptionIcon={hasContactManageAccess(apiRoutesPermissionAssignment, userDetail) && !isGenericTag(option?.contact_list_id)}
                                                    onClickOfDeleteOption={(e: React.MouseEvent<HTMLDivElement, MouseEvent>, option: tagDataInterface) => {e.stopPropagation(); onClickOfDeleteTag(option)}}
                                                />
                                        )}}
                                        getOptionDisabled={(option) => isOptOutMetaTag(option?.contact_tag_name)}
                                        renderInput={params => {
                                            const { InputProps, ...restParams } = params;
                                            const { startAdornment, ...restInputProps } = InputProps;
                                            return (
                                                <TextField
                                                    {...restParams}
                                                    placeholder='Select Tags'
                                                    InputProps={{
                                                        ...restInputProps,
                                                        startAdornment: (
                                                            <div className={styles.selectTagTextField}>
                                                                {startAdornment}
                                                            </div>
                                                        ),
                                                    }}
                                                />
                                            );
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                }
                <Grid item sx={{ marginTop: "25px" }}>
                    <Grid container gap="15px" justifyContent={"center"}>
                        <Grid item>
                            <GlobalButton sx={{ minWidth: "140px" }} className='borderedButtonStyle' buttonText="Cancel" onClick={handleClose} />
                        </Grid>
                        <Grid item>
                            <GlobalButton sx={{ minWidth: "140px" }} className={contactTagActionData.flagAssignTag ? 'primaryButtonStyle' : "deleteButton"} buttonText={contactTagActionData.flagAssignTag ? "Save" : "Delete"} onClick={handleSaveAction} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ContactTagActionPopup